import { render, staticRenderFns } from "./SubscriptionPlanItem.vue?vue&type=template&id=1d83db4e"
import script from "./SubscriptionPlanItem.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlanItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports